/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { visuallyHiddenCss } from '@chegg-ui/theme';
import { getBaseInputStyles } from '@chegg-ui/input';
import styled, { css } from 'styled-components';
export var FauxInputCombobox = styled.div.withConfig({
  componentId: "sc-1a1otbk-0"
})([""]);
export var AutocompleteInput = styled.input.withConfig({
  componentId: "sc-1a1otbk-1"
})(["", ""], function (props) {
  return css(["", ""], getBaseInputStyles(props));
});
export var AriaLive = styled.div.withConfig({
  componentId: "sc-1a1otbk-2"
})(["", ""], visuallyHiddenCss);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/autocomplete/dist/esm/styles.js
// module id = 4510
// module chunks = 11